import { AfterViewInit, Component, Input, inject } from '@angular/core';
import {HydraService} from '../../../core/services/hydra.service';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {ActivityInterface} from '../../../class/api/Activity';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {LocalStorage} from "ngx-webstorage";
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatListItemAvatar } from '@angular/material/list';
import { LogCommentsListComponent } from './log-comments-list/log-comments-list.component';

@Component({
    selector: 'app-log',
    templateUrl: './log.component.html',
    styleUrls: ['./log.component.scss'],
    imports: [MatIcon, MatListItemAvatar, LogCommentsListComponent, DatePipe]
})
export class LogComponent implements AfterViewInit {
    private hydraService = inject(HydraService);
    private authService = inject(AuthentificationService);

    @LocalStorage() public dateShort;

    @Input() target: string = null;
    @Input() showHistory = true;
    @Input() showTasks = true;
    @Input() showCompletedTasks = true;
    @Input() showOriginDateTime = false;

    @Input() minWeightLevel: number;
    @Input() maxWeightLevel: number;

    @Input() since: Date | string;

    @Input() pageNumber = 1;
    @Input() itemsPerPage = 500;

    public totalElements = 0;

    public activities: ActivityInterface[] = [];

    public isAdmin = false;

    constructor() {
        this.isAdmin = this.authService.isAdmin();
    }

    private construcUrlCollection() {
        let url = api.activities;

        let sepa = '?';

        //Url params target /api/activities?target=%20api%20dossier
        if (this.target != null && this.target != '') {
            url = url + sepa + 'target=' + this.target;
            sepa = '&';
        }

        if (!this.showHistory) {
            url += sepa + 'task=true';
            sepa = '&';
        } else if (!this.showTasks) {
            url += sepa + 'task=false';
            sepa = '&';
        }

        if (this.minWeightLevel) {
            url += sepa + 'weightLevel[gte]=' + this.minWeightLevel;
            sepa = '&';
        }

        if (this.maxWeightLevel) {
            url += sepa + 'weightLevel[lte]=' + this.maxWeightLevel;
            sepa = '&';
        }

        if (this.maxWeightLevel) {
            url += sepa + 'weightLevel[lte]=' + this.maxWeightLevel;
            sepa = '&';
        }

        if(!this.isAdmin) {
            url += sepa + 'privacyLevel[gte]=99';
            sepa = '&';
        }

        if (!this.showCompletedTasks) {
            url += sepa + 'taskComplete=false';
            sepa = '&';
        }

        if (this.since) {
            const dateString = typeof this.since == 'string' ? this.since : this.since.toISOString();
            url += sepa + 'actionDateTime[after]=' + dateString;
            sepa = '&';
        }

        ///Pagination /api/activities?target=%20api%20dossier&search=toto&page=1
        if (this.pageNumber) {
            url += sepa + 'page=' + this.pageNumber;
            sepa = '&';
        }

        if (this.itemsPerPage) {
            url += sepa + 'itemsPerPage=' + this.itemsPerPage;
            sepa = '&';
        }

        return url;
    }

    public getCollection(url) {
        this.hydraService.getList(url).subscribe((res: HydraCollection) => {
            this.totalElements = +res['hydra:totalItems'];
            this.activities = new HydraCollection(res).getMember();
        });
    }

    public _timeout = null;

    public loadActivities() {
        this.getCollection(this.construcUrlCollection());
    }

    public showCommentBox(activity) {
        activity['showCommentBox'] = true;
    }

    ngAfterViewInit() {
        this.loadActivities();
    }

    public isActivityDesistement(activity) {
        if(activity.action.includes('desistement')) {
            return true;
        }
        return false;
    }

    public isMessageOldDesistement(activity) {
        if(activity.data?.activity?.action === 'desistementATraiter') {
            return true;
        }
        return false;
    }
}
